/**
 * Created by olga on 24.09.2025
 */

const ThirdElement = function (unit, options) {
    UnitComponent.call(this, unit);

    this.prize = options.prize;
    if (options.prizeCode !== undefined && options.prizeStage !== undefined) {
        this.prize = {
            code: String.fromCharCode(options.prizeCode),
            stage: options.prizeStage
        };
    }

    this.price = LinePrices[this.prize.code] && LinePrices[this.prize.code][this.prize.stage];

    this.timeStart = Date.now();
    this.duration = options.time !== undefined ? options.time : cleverapps.parseInterval(ThirdElement.DURATION);
    this.timeout = new cleverapps.LongTimeout(this.reject.bind(this), this.duration);

    cleverapps.metrics.logEvent(cleverapps.EVENTS.THIRD_ELEMENT_COUNT);
};

ThirdElement.prototype = Object.create(UnitComponent.prototype);
ThirdElement.prototype.constructor = ThirdElement;

ThirdElement.prototype.onAppearance = function () {
    if (this.view) {
        this.view.bubbleAppearance();
    }
};

ThirdElement.prototype.onBuying = function (unit, options) {
    if (this.view) {
        this.view.playBuying(unit, options);
    }
};

ThirdElement.prototype.onDestruction = function (cb) {
    if (this.view) {
        this.view.playDestruction(cb);
    }
};

ThirdElement.prototype.destructor = function () {
    clearTimeout(this.timeout);
    if (this.pendingRejectHandler) {
        this.pendingRejectHandler.clear();
        this.pendingRejectHandler = undefined;
    }
    runCleaners(this);
};

ThirdElement.prototype.getTimeLeft = function () {
    return Math.max(0, this.timeStart + this.duration - Date.now());
};

ThirdElement.prototype.reject = function () {
    const field = Merge2.current.field;
    if (field.dragging === this.unit) {
        if (!this.pendingRejectHandler) {
            this.pendingRejectHandler = field.on("changeDragging", (dragUnit) => {
                if (dragUnit !== this.unit) {
                    cleverapps.timeouts.setTimeout(() => {
                        this.pendingRejectHandler.clear();
                        this.pendingRejectHandler = undefined;
                        this.reject();
                    }, 0);
                }
            }, this);
        }
        return;
    }

    if (this.onRejectListener) {
        this.onRejectListener();
    }

    const x = this.unit.x;
    const y = this.unit.y;
    Merge2.current.counter.inc();
    this.onDestruction(() => {
        Merge2.current.spawn([MergeComponent.BONUS_UNIT], { x, y }, { effect: "merge.spawn.bonus_star_bubble" });
        cleverapps.playSession.logEvent(cleverapps.EVENTS.THIRD_EL_BONUS);
        Merge2.current.counter.dec();
    });
    this.unit.onDestruction();
    this.unit.remove(true);
};

ThirdElement.IsAvailable = function (unit) {
    if (cleverapps.gameModes.skipThirdElement) {
        return false;
    }

    if (!LinePrices[unit.code] || !LinePrices[unit.code][unit.stage]) {
        return false;
    }

    if (!cleverapps.user.checkAvailable(cleverapps.config.availables.THIRD_ELEMENT)) {
        return false;
    }

    if (!Merge2.current.thirdElementPlanner.checkAvailable()) {
        return false;
    }

    if (!cleverapps.unitsLibrary.isOpened(unit)) {
        return false;
    }

    const family = Families[unit.code];
    if (family.type !== "resource" || family.sideQuest) {
        return false;
    }

    return unit.stage <= ThirdElement.STAGES.max;
};

ThirdElement.prototype.isAdsAvailable = function () {
    return cleverapps.adsLimits.state(AdsLimits.TYPES.THIRD_ELEMENT_CREATE) === AdsLimits.STATE_READY && this.prize.stage <= ThirdElement.STAGES.adsMax;
};

ThirdElement.prototype.accept = function (options) {
    options = options || {};

    if (this.collected) {
        return;
    }

    let x = this.unit.x;
    let y = this.unit.y;
    const mapUnit = Merge2.current.field.getUnit(x, y);

    if (mapUnit === this.unit) {
        this.unit.liftUnitFromMap();
    } else if (mapUnit) {
        const cell = Merge2.current.field.findEmptySlot(x, y);
        if (!cell) {
            return;
        }
        x = cell.x;
        y = cell.y;
    }

    const unit = new Unit(this.prize);
    unit.setPosition(x, y);
    Merge2.current.field.addUnit(x, y, unit);
    Merge2.current.field.onAddUnit(x, y, unit);
    Merge2.current.field.onUnitAvailable(unit);
    this.onBuying(unit, options);

    this.collected = true;

    if (mapUnit === this.unit) {
        this.unit.remove(true);
    }

    Merge2.current.field.selectUnit(unit);

    const data = { unit, affected: this.unit };
    Field.mapEvent(Field.SPAWN, data);
    cleverapps.tutorial.trigger(Field.SPAWN);
};

ThirdElement.prototype.getProduct = function () {
    return Product.CreateByHardPrice(this.price, {
        type: "third_element",
        expedition: cleverapps.meta.selectedLocationId()
    }, []);
};

ThirdElement.prototype.buy = function (callback) {
    const product = this.getProduct();

    if (product) {
        product.buy((success) => {
            if (success) {
                this.accept();
            }
            callback(success);
        });
    } else {
        callback(false);
    }
};

ThirdElement.prototype.watch = function (callback) {
    cleverapps.rewardedAdsManager.playRewarded(
        AdsLimits.TYPES.THIRD_ELEMENT_CREATE,
        () => {
            this.accept();
            callback && callback(true);
        },
        () => {
            callback && callback(false);
        }
    );
};

ThirdElement.prototype.handleClick = function () {
    const selection = Merge2.current.field.lastSelection;
    if (!selection || this.unit.x !== selection.x || this.unit.y !== selection.y) {
        return false;
    }

    this.unit.squeeze();

    cleverapps.focusManager.display({
        focus: "thirdElementWindow",
        control: "MenuBarGoldItem",
        actions: [
            function (f) {
                setTimeout(f, 300);
            },

            function (f) {
                new ThirdElementWindow(this);
                cleverapps.focusManager.onceNoWindowsListener = f;
            }.bind(this)
        ]
    });

    return true;
};

ThirdElement.PROBABILITY = [0.05, 0.05, 0.05, 0.05, 0.05];
ThirdElement.LIMIT = 5;

ThirdElement.DURATION = "1 minutes";

ThirdElement.STAGES = {
    max: 12,
    adsMax: 8
};

MergeComponent.BONUS_UNIT = { code: "qq", stage: 0 };
